import { css } from 'lit';
export const checkboxStyles = css `
  .checkbox-container {
    box-sizing: border-box;
    width: fit-content;
    display: flex;
    color: var(--checkbox-text-color, var(--synapse-color-neutral-8));
  }

  .checkbox-container.disabled {
    color: var(--checkbox-disabled-bg-color, var(--icon-color-disabled));
    cursor: not-allowed;
  }

  .checkbox-container.group-checkbox {
    margin-left: -15px;
  }

  .checkbox-container * {
    box-sizing: border-box;
  }

  .checkbox-container input {
    position: absolute;
    visibility: hidden;
  }

  .checkbox-container label {
    user-select: none;
    overflow: hidden;
    display: flex;
    align-items: center;
    font-size: 16px;
    cursor: pointer;
  }

  .checkbox-container.disabled label {
    pointer-events: none;
  }

  .checkbox-container label span {
    display: flex;
    width: 16px;
    height: 16px;
    border-radius: 4px;
    border: 2px solid var(--checkbox-border-color, var(--border-color-default));
    background-color: var(--checkbox-bg-color, var(--surface-color-default));
  }

  .checkbox-container.disabled span {
    border: 2px solid var(--checkbox-disabled-border-color, var(--interactive-color-disabled));
  }

  .checkbox-container label span svg,
  .checkbox-container label span synapse-icon,
  .checkbox-container label span .icon {
    left: 0;
    --goto-icon-color: var(--checkbox-bg-color, var(--icon-color-inverted));
    fill: var(--checkbox-bg-color, var(--icon-color-inverted));
    width: 12px;
    height: 12px;
  }

  .checkbox-container label span synapse-icon {
    --goto-icon-size: 150%;
    margin: -25%;
  }

  .checkbox-container.large {
    padding: 2px 0;
  }

  .checkbox-container.large label span {
    width: 20px;
    height: 20px;
  }

  .checkbox-container.large label span svg,
  .checkbox-container.large label span synapse-icon,
  .checkbox-container.large label span .icon {
    width: 16px;
    height: 16px;
  }

  .checkbox-container.disabled label span svg,
  .checkbox-container.disabled label span synapse-icon,
  .checkbox-container.disabled label span .icon {
    --goto-icon-color: var(--icon-color-inverted);
    fill: var(--icon-color-inverted);
  }

  .checkbox-container label div:first-child {
    padding-right: 10px;
  }

  .checkbox-container label div:last-child {
    padding-left: 10px;
  }

  .checkbox-container label:hover span {
    background-color: var(--checkbox-hovered-color, var(--surface-color-brand-secondary));
    border: 2px solid var(--checkbox-selected-color, var(--surface-color-brand-default));
  }

  .checkbox-container label:hover span svg,
  .checkbox-container label:hover span synapse-icon,
  .checkbox-container label:hover span .icon {
    visibility: hidden;
  }

  .checkbox-container.disabled label:hover span {
    border: 2px solid var(--checkbox-disabled-border-color, var(--synapse-color-neutral-4));
    background-color: var(--checkbox-disabled-bg-color, var(--synapse-color-neutral-2));
  }

  .checkbox-container input:checked + label span {
    background: var(--checkbox-selected-color, var(--surface-color-brand-default));
    border-color: var(--checkbox-selected-color, var(--surface-color-brand-default));
  }

  .checkbox-container input:checked:hover + label span {
    background: var(--checkbox-selected-hovered-color, var(--interactive-color-brand-hover));
    border-color: var(--checkbox-selected-hovered-color, var(--interactive-color-brand-hover));
  }

  .disabled.checkbox-container input:checked + label span {
    background: var(--checkbox-disabled-border-color, var(--icon-color-disabled));
    border-color: var(--checkbox-disabled-border-color, var(--icon-color-disabled));
  }

  .disabled.checkbox-container input:checked:hover + label span {
    background: var(--checkbox-disabled-border-color, var(--icon-color-disabled));
    border-color: var(--checkbox-disabled-border-color, var(--icon-color-disabled));
  }

  .checkbox-container input:checked + label span svg,
  .checkbox-container input:checked + label span synapse-icon,
  .checkbox-container input:checked + label span .icon {
    stroke-dashoffset: 0;
  }

  .checkbox-container input:checked + label span svg,
  .checkbox-container input:checked + label span synapse-icon,
  .checkbox-container input:checked + label span .icon {
    --goto-icon-color: var(--icon-color-inverted);
    visibility: visible;
  }

  .checkbox-container:hover input:checked~label span {
    background: var(--checkbox-selected-hovered-color, var(--interactive-color-brand-hover));
    border-color: var(--checkbox-selected-hovered-color, var(--interactive-color-brand-hover));
  }
`;
export default checkboxStyles;
